import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Input, Spinner, palette, Typography, InlineMessage } from "@callcenter/voiso-design-system"

import { RootState, authActions } from "../ducks"
import { useGoogleAuth } from "./login-form.hooks"

import styles from "../login.module.scss"
import { GoogleLogin } from "@react-oauth/google"

export const LoginForm = () => {
  const dispatch = useDispatch()

  const email = useSelector<RootState, string>(({ authorization }) => authorization.email)
  const password = useSelector<RootState, string>(({ authorization }) => authorization.password)
  const isLoading = useSelector<RootState, boolean>(({ authorization }) => authorization.isLoading)
  const formErrors = useSelector<RootState, Record<string, string>>(({ authorization }) => authorization.formErrors)
  const { googleErrors, handleGoogleSignIn, onSuccess, onError } = useGoogleAuth()

  return (
    <>
      <div className={styles.form}>
        <Input.Base
          value={email}
          onChange={(value) => dispatch(authActions.changeField({ field: "email", value }))}
          label="Email"
          placeholder="Enter email address"
          isError={Boolean(formErrors?.email)}
          hint={formErrors?.email}
        />
        <Input.Password
          value={password}
          onChange={(value) => dispatch(authActions.changeField({ field: "password", value }))}
          label="Password"
          placeholder="Enter password"
          isError={Boolean(formErrors?.password)}
          hint={formErrors?.password}
        />
      </div>
      <div className={styles.buttonsContainer}>
        <Button onClick={() => dispatch(authActions.submitForm({ email, password }))}>
          {isLoading ? <Spinner size={16} color={palette.blue6} /> : "Login"}
        </Button>

        <button type="button" onClick={handleGoogleSignIn} className={styles.googleSignInButton}>
          <svg
            className={styles.googleLogo}
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_3911_1650)">
              <path
                d="M28.1673 14.2619C28.1673 13.1148 28.0742 12.2777 27.8727 11.4096H14.7734V16.5872H22.4624C22.3075 17.8739 21.4704 19.8117 19.6101 21.1138L19.584 21.2872L23.7257 24.4957L24.0127 24.5244C26.648 22.0905 28.1673 18.5095 28.1673 14.2619Z"
                fill="#4285F4"
              />
              <path
                d="M14.7723 27.9038C18.5393 27.9038 21.7017 26.6636 24.0116 24.5244L19.609 21.1138C18.4308 21.9354 16.8496 22.509 14.7723 22.509C11.0829 22.509 7.95145 20.0753 6.83519 16.7113L6.67157 16.7252L2.36491 20.0582L2.30859 20.2147C4.60288 24.7723 9.31554 27.9038 14.7723 27.9038Z"
                fill="#34A853"
              />
              <path
                d="M6.83508 16.7113C6.54054 15.8432 6.37008 14.913 6.37008 13.9519C6.37008 12.9907 6.54054 12.0606 6.81958 11.1925L6.81178 11.0076L2.45115 7.62112L2.30848 7.68899C1.36289 9.58027 0.820312 11.7041 0.820312 13.9519C0.820312 16.1997 1.36289 18.3234 2.30848 20.2147L6.83508 16.7113Z"
                fill="#FBBC05"
              />
              <path
                d="M14.7723 5.3947C17.3921 5.3947 19.1594 6.52635 20.167 7.47205L24.1046 3.6275C21.6863 1.37969 18.5393 0 14.7723 0C9.31554 0 4.60288 3.1314 2.30859 7.68899L6.81969 11.1925C7.95145 7.82857 11.0829 5.3947 14.7723 5.3947Z"
                fill="#EB4335"
              />
            </g>
            <defs>
              <clipPath id="clip0_3911_1650">
                <rect width="28" height="28" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>
          <Typography.TopHeader className={styles.signInButtonText}>Sign in with Google</Typography.TopHeader>
        </button>
        {googleErrors && <InlineMessage type={InlineMessage.type.error}>{googleErrors}</InlineMessage>}
        <div style={{ display: "none" }} className="google-sign-in">
          <GoogleLogin onSuccess={onSuccess} onError={onError} />
        </div>
      </div>
    </>
  )
}
